/*
Veneer
--species <string::enum> | [<Any Lumber Species>]
--core <string::enum> | ['Particle Board', 'MDF']
--coreThickness <float> | inches
--match <string::enum> | ['Sequence', 'Book', 'Slip']

--grade <boolean::switch> | ['Good 1 Side', 'Good 2 Side']

NOTE: These 2 attributes are rare, can be considered custom for veneers, ignore on reports
--moistureResistant <boolean::checkbox>
--fireRated <boolean::checkbox>

--manufacturers {
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
}
*/
import { decimal, minValue } from 'vuelidate/lib/validators'
import {
  certification,
  cut,
  length,
  thickness,
  species,
  width
} from '@/modules/standardItems/schemas/baseFormFields'
import { manufacturers } from '@/modules/standardItems/schemas/sheetStock/form'

export default [
  thickness({ classes: ['xs12', 'sm4', 'input--short'], autofocus: true }),
  width({ classes: ['xs12', 'sm4', 'input--short'] }),
  length({ classes: ['xs12', 'sm4', 'input--short'] }),
  species({ classes: ['xs12', 'sm4'] }),
  cut(),
  certification({ classes: ['xs12', 'sm4'] }),
  {
    key: 'core',
    value: 'core',
    type: 'select',
    default: 'MDF',
    classes: ['xs12', 'sm4', 'input__wrapper'],
    attributes: {
      label: 'Core',
      required: true,
      class: ['input--dense']
    },
    values: ['MDF', 'Particle Board', 'Veneer']
  },
  {
    key: 'coreThickness',
    value: 'coreThickness',
    type: 'float',
    required: true,
    delayTouch: true,
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Core Thickness',
      suffix: 'in',
      class: ['input--dense'],
      required: true
    },
    validation: [
      {
        validationKey: 'decimal',
        validationFunction: decimal,
        errorMessage: 'This should be a number'
      },
      {
        validationKey: 'minValue',
        validationFunction: minValue(0.0001),
        errorMessage: 'This needs a core thickness'
      }
    ]
  },
  {
    key: 'grade',
    value: 'grade',
    type: 'radio',
    default: 'MDF',
    classes: ['xs12', 'sm4', 'input__wrapper'],
    attributes: {
      label: 'Grade',
      required: true,
      class: ['input--dense']
    },
    values: [
      {
        label: 'Good 1 Side',
        value: 'Good 1 Side'
      },
      {
        label: 'Good 2 Side',
        value: 'Good 2 Side'
      }
    ]
  },
  {
    key: 'match',
    value: 'match',
    type: 'select',
    default: 'Book',
    classes: ['xs12', 'sm4', 'input--medium'],
    attributes: {
      label: 'Match',
      class: ['input--dense']
    },
    values: ['Sequence', 'Book', 'Slip']
  },
  {
    key: 'centered',
    value: 'centered',
    type: 'radio',
    default: true,
    classes: ['xs12', 'sm4', 'input__wrapper'],
    attributes: {
      label: 'Centered',
      class: ['input--dense']
    },
    values: [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ]
  },
  {
    key: 'prefinished',
    value: 'prefinished',
    type: 'checkbox',
    classes: ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
    attributes: {
      label: 'Prefinished',
      class: ['input--dense']
    }
  },
  manufacturers()
]
